export default {
  SET_FORM_VALUES: 'FORM / SET FORM VALUES',
  SET_FORM_VALIDATION: 'FORM / SET FORM VALIDATION',
  SET_FOCUS: 'FORM / SET FOCUS',
  SET_FEEDBACK: 'FORM / SET FEEDBACK',
  SET_CTA_STATE: 'FORM / SET CTA STATE',
} as const;
